import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import Global from '../../store/global-selectors';
import { HooksDisplayGrid } from 'ui-components/components/hooks-display-grid';
import GridLoading from '../../components/grid-loading';
import { returnsGridColumns } from '../../components/returns-grid/columns';
import * as SelectedReturnsActions from '../../store/returns/selected-returns/returns.selected-returns.actions';
import { returnsGridChangeColumns, returnsGridChangeOrderBy } from '../../store/returns/grid/returns.grid.actions';
import { OrderDetailsHelperService } from '../../services/order-details-helper-service';
import { ReturnsPlaceholder } from './placeholder';

const selectGridData = createSelector([Global.selectReturnsGridReturns], (returns) =>
  returns.map((returnObject) => ({
    fulfillmentId: returnObject.fulfillmentId,
    id: returnObject.fulfillmentId,
  })),
);

const mapConfiguration = (columnConfiguration) => {
  return columnConfiguration
    .filter((column) => {
      return returnsGridColumns.find((c) => c.id === column.id);
    })
    .map((column) => {
      const baseColumn = returnsGridColumns.find((c) => c.id === column.id);
      const messageDescriptor = baseColumn.getMessageDescriptor && baseColumn.getMessageDescriptor();
      const name = <FormattedMessage {...messageDescriptor} />;

      return {
        ...column,
        render: baseColumn.render,
        name,
        id: baseColumn.id,
      };
    });
};

const mapConfirmationTextToOrderSelector = createSelector(
  (gridData) => gridData,
  (_, carriers) => carriers,
  (gridData, carriers) => {
    return OrderDetailsHelperService.mapConfirmationTextToOrder(gridData, carriers);
  },
);

const mapStatesToProps = (state) => {
  const isLoading = Global.selectReturnsGridIsLoading(state);
  const statusViewId = Global.selectReturnsNavSelectedViewId(state);
  const columnConfiguration = Global.selectReturnsGridUserGridConfigOrDefault(state, { statusViewId });
  const gridData = selectGridData(state);
  const carriers = Global.selectReferenceDatagetSellerCarriers(state);
  const mappedGridData = mapConfirmationTextToOrderSelector(gridData, carriers);
  return {
    columns: mapConfiguration(columnConfiguration),
    data: mappedGridData,
    selected: Global.selectSelectedReturnsSelectedReturnIds(state),
    getColumnId: (column) => column.id,
    placeholder: isLoading ? <GridLoading /> : <ReturnsPlaceholder />,
    statusViewId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onColumnsChanged: (statusViewId, columns) => {
      dispatch(returnsGridChangeColumns(statusViewId, columns));
    },
    onOrderByChanged: (statusViewId, columns) => {
      dispatch(returnsGridChangeOrderBy(statusViewId, columns));
    },
    onSelectedChanged: (selectedReturnIds) => {
      dispatch(SelectedReturnsActions.setSelectedReturns(selectedReturnIds));
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { statusViewId } = stateProps;
  return {
    ...stateProps,
    ...dispatchProps,
    onColumnsChanged: (columns) => dispatchProps.onColumnsChanged(statusViewId, columns),
    onOrderByChanged: (columns) => dispatchProps.onOrderByChanged(statusViewId, columns),
    ...ownProps,
  };
};

export const ReturnsGridContainer = connect(mapStatesToProps, mapDispatchToProps, mergeProps, {
  pure: false,
})(HooksDisplayGrid);
